// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"279":"237e9196","495":"5f4939fb","502":"dec4c112","524":"b3f7835e","802":"237e9196"}[chunkId] + ".chunk.css";
};